import { Observable } from 'rxjs';

import {
  AddInternalNotificationRecipientPayload,
  InternalNotificationRecipient,
  InternalNotificationRecipientOptions,
  InternalNotificationsResponse,
} from '../../../interfaces/internal-notification.interface';

/**
 * Único punto de acceso a datos de Comunicación interna (`/internal-notifications`).
 *
 * Clase abstracta y no interfaz por la misma razón que `MailingApiService`:
 * Angular necesita un token de inyección en tiempo de ejecución.
 */
export abstract class InternalNotificationsApiService {
  /** Todos los avisos internos con sus destinatarios */
  abstract getNotifications(): Observable<InternalNotificationsResponse>;

  /** Personas, roles y permisos que se pueden agregar */
  abstract getRecipientOptions(): Observable<InternalNotificationRecipientOptions>;

  abstract addRecipient(
    notificationId: number,
    payload: AddInternalNotificationRecipientPayload,
  ): Observable<InternalNotificationRecipient>;

  /** Quita un destinatario; devuelve cómo estaba */
  abstract removeRecipient(
    notificationId: number,
    recipientId: number,
  ): Observable<InternalNotificationRecipient>;
}
